import { render } from "./CardSistemaRh.vue?vue&type=template&id=c0284c74"
import script from "./CardSistemaRh.vue?vue&type=script&lang=js"
export * from "./CardSistemaRh.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__